import { DownloadRegistryFacade } from './download-registry.facade';
import { SelectedTextbookFacade } from './selected-textbook.facade';
import { ShelfFacade } from './shelf.facade';
import { TextbooksFacade } from './textbooks.facade';

const facades = [TextbooksFacade, DownloadRegistryFacade, SelectedTextbookFacade, ShelfFacade];

export { facades, TextbooksFacade, DownloadRegistryFacade, SelectedTextbookFacade, ShelfFacade };
